export default "__VITE_ASSET__Ddq3zKuC__"